import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { TMediaResponsiveConfig } from '@x/common/media-thumbnail/media-thumbnail.config';
import { Html5PlayerComponent } from '@x/common/media/html5-player/html5-player.component';
import { IShopProductMediaItem } from '@x/ecommerce/shop-client';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'x-product-media',
  templateUrl: './product-media.component.html',
  styleUrls: ['./product-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-product-media' },
})
export class ProductMediaComponent {
  private _responsiveConfig: TMediaResponsiveConfig = {
    XS: { width: 170, height: 170 },
    SM: { width: 250, height: 250 },
    MD: { width: 350, height: 350 },
    LG: { width: 350, height: 350 },
    XL: { width: 350, height: 350 },
    XXL: { width: 350, height: 350 },
  };

  @Input() id: string;
  @Input() media: IShopProductMediaItem;
  @Input() width: number = 350;
  @Input() height: number = 350;
  @Input() videoAutoplay: boolean = true;
  @Input() controls: boolean = false;
  @Input() blurHash: string | undefined | null;
  @Output() mediaLoaded = new EventEmitter<any>();
  @Input() set responsiveConfig(config: TMediaResponsiveConfig | undefined) {
    if (!config) return;

    this._responsiveConfig = { ...config };
  }

  get responsiveConfig(): TMediaResponsiveConfig {
    return this._responsiveConfig;
  }

  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  @ViewChild('HTML5_PLAYER') html5Player: Html5PlayerComponent;

  onMediaLoaded() {
    this.loading$.next(false);
    this.mediaLoaded.emit();
  }
}
